export default __webpack_public_path__ + "static/media/fantacode.c78938b0.png";